
import { defineComponent, ref, reactive, toRefs, onMounted, computed, nextTick, watch } from 'vue'
import { DoubleRightOutlined } from '@ant-design/icons-vue'
import router from '@/router/index'
import { useRoute } from 'vue-router'
import Navatop from '@/components/navtop.vue'
import api from '@/api/allApi'
import Table from '@/components/table.vue'
import Nodata from '@/components/page/nodata.vue'
export default defineComponent({
  components: { Table, Nodata },
  props: {
    itemdata: {
      type: Object,
      default: function() {
        return {}
      }
    },
    pageSourceData: {
      type: Object,
      default: function() {
        return {}
      }
    }
  },
  setup(props: any, context) {
    const pageData: any = reactive({
      data: [],
      columns: [],
      spinning: true
    })
    pageData.columns = [
      {
        title: '公告日期',
        dataIndex: 'time',
        key: 'time',
        width: '120px'
      },
      {
        title: '公告标题',
        dataIndex: 'ggTitle',
        key: 'ggTitle',
        slots: { customRender: 'link', type: 'link' },
        // width: '500px',
        ellipsis: true
      }
    ]
    const moment = require('moment')
    watch(
      () => (props.pageSourceData || {}).Noti || [],
      () => {
        const _data = (props.pageSourceData || {}).Noti || []
        if (_data.length) {
          _data.forEach((item: any, i: any) => {
            item.index = 'Noti' + i
            item.ggTitle = item.Title
            item.time = moment(item.PubTime * 1000).format('YYYY-MM-DD')
          })
        }
        nextTick(() => {
          pageData.spinning = false
        })
        pageData.data = _data
      },
      { deep: true }
    )
    return {
      ...toRefs(pageData)
    }
  }
})
